import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AccountService from '../../services/account.service';
import Modal from '../subcomponents/Modal';
import { TextField, DialogActions, DialogContent, Button } from '@mui/material';

const MS_PER_DAY = 1000 * 60 * 60 * 24;

const TrialModal = ({ open, onClose, accountId, trialDuration, trialStartDate, onSuccess }) => {
  const [trialDays, setTrialDays] = useState(0);

  useEffect(() => {
    setTrialDays(0);
  }, [trialDuration]);

  const handleClose = () => {
    setTrialDays(0);
    onClose();
  };

  const handleUpdateTrial = () => {
    // `trialDuration` is counted from `trialStartDate`, so the trial ends at
    // `trialStartDate + trialDuration`. To give the customer the typed number of
    // days starting today, the new duration must cover the time already elapsed
    // plus any days still left, plus the days being added.
    const elapsedDays = (new Date() - new Date(trialStartDate)) / MS_PER_DAY;
    const daysLeft = Math.max(0, trialDuration - elapsedDays);
    const newDuration = Math.ceil(elapsedDays + daysLeft + parseInt(trialDays));
    AccountService.updateTrial(accountId, newDuration)
      .then(() => {
        onSuccess();
        handleClose();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Modal open={open} title={'Add Trial Days'}>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Trial Days to add"
          type="number"
          fullWidth
          variant="outlined"
          value={trialDays}
          onChange={(e) => setTrialDays(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleUpdateTrial} variant="contained">
          Update
        </Button>
      </DialogActions>
    </Modal>
  );
};

TrialModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
  trialDuration: PropTypes.number.isRequired,
  trialStartDate: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired
};

export default TrialModal;
